import { hasKey } from '@/lib/history-key/cipher';

import { lookupSession } from './browser-client';

/** Only the lookup installs keys: a reply superseded by a sign-out meanwhile installs nothing. */
export async function ensureKey({ owner, tenant }: { owner: string; tenant: string }) {
  if (hasKey(owner)) return;
  await lookupSession({ tenant });
  if (!hasKey(owner)) throw new Error('history key unavailable for this conversation');
}
